export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const CONFIG_UPDATED = 'CONFIG_UPDATED';
export const ADD_FILES = 'ADD_FILES';
export const REMOVE_FILE = 'REMOVE_FILE';
export const UPLOAD_ALL_FILES = 'UPLOAD_ALL_FILES';
export const UPLOAD_ALL_FILES_DONE = 'UPLOAD_ALL_FILES_DONE';
export const UPLOAD_FILE = 'UPLOAD_FILE';
